import { useQuery } from '@tanstack/react-query';
import { Pin, ChevronDown } from 'lucide-react';
import { getPinnedMessages } from '../../services/chatChannelService';

interface Props {
  channelId: string;
  onToggleList: () => void;
  onJumpToMessage: (messageId: string) => void;
}

export default function PinnedMessageBanner({ channelId, onToggleList, onJumpToMessage }: Props) {
  const { data } = useQuery({
    queryKey: ['pinnedMessages', channelId],
    queryFn: () => getPinnedMessages(channelId, 1, 1),
    staleTime: 30_000,
  });

  const latestPin = data?.pins?.[0];
  if (!latestPin) return null;

  return (
    <div
      className="flex items-center gap-2 px-4 py-2 bg-yellow-50 border-b text-sm cursor-pointer hover:bg-yellow-100 shrink-0"
      onClick={() => onJumpToMessage(latestPin.messageId)}
    >
      <Pin className="size-4 text-yellow-600 shrink-0" />
      <span className="truncate flex-1 text-gray-700">{latestPin.message.content}</span>
      <button
        onClick={(e) => { e.stopPropagation(); onToggleList(); }}
        className="text-gray-400 hover:text-gray-600 shrink-0 p-0.5"
      >
        <ChevronDown className="size-4" />
      </button>
    </div>
  );
}
